import AddressListPage from './AddressList';

export default AddressListPage;